<template>
  <div v-if="!isIdealEUplan">
    <public-announcement :is-fixed="true" />
    <MonthlyToYearlyPromoContainer />
    <div class="referral">
      <page-breadcrumb
        :category="$i18nPresenter.t('account')"
        :text="breadcrumbText"
      />

      <div class="referral-content">
        <aha-section class="relative">
          <template #header>
            <h5>{{ $i18nPresenter.t('Refer friends and earn up to 100 USD') }}</h5>
          </template>
          <template #body>
            <ReferralCode class="mt-2 mb-8" v-if="currentUser.id" />
            <img src="@/assets/images/icon/invite-friend.png" class="invite-friend" width="390">
          </template>
        </aha-section>
        <ReferrerHistory />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

// UI
import PageBreadcrumb from '../common/page-breadcrumb/PageBreadcrumb.vue'
import ReferrerHistory from '@/components-v2/referral/ReferrerHistory.vue'
import ReferralCode from '@/components-v2/common/referral-code/ReferralCode.vue'
import PublicAnnouncement from '@/components-v2/common/global-notification/PublicAnnouncement.vue'
import MonthlyToYearlyPromoContainer from '@/components-v2/common/global-notification/MonthlyToYearlyPromoContainer.vue'

export default {
  components: {
    PageBreadcrumb,
    ReferrerHistory,
    ReferralCode,
    PublicAnnouncement,
    MonthlyToYearlyPromoContainer,
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    breadcrumbText() {
      return this.$i18nPresenter.t('Refer a Friend')
    },
    isIdealEUplan() {
      return this.currentUser.currency === 'eur'
    },
  },
  mounted() {
    if (this.isIdealEUplan) this.$router.push({ name: 'Error404' })
  },
}
</script>

<style lang="scss" scoped>
.referral {
  @apply p-4 md:px-10 md:py-6 md:pb-20;
}
.referral-content {
  @apply flex flex-col justify-center md:w-10/12 md:mx-auto;
}
.invite-friend {
  position: absolute;
  bottom: 0;
  right: 0;

  @media (max-width: 1024px) {
    position: inherit;
    margin: 0 auto;
  }
}
</style>
